import { render, staticRenderFns } from "./mudarpermissao.vue?vue&type=template&id=26e0ece4&"
import script from "./mudarpermissao.vue?vue&type=script&lang=js&"
export * from "./mudarpermissao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports